export enum BorderStyleEnum {
  none = 'none',
  dotted = 'dotted',
  dashed = 'dashed',
  solid = 'solid',
}
